/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail/AddEmail/Content/Name",
  isInvalid,
  onChange
  
}) {
let selectedNameValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'name',
})
let selectedNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'selected',
path: 'name',
validate: fromValidate.name,
})
let selectedNameChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'name',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 marginTop={0}
 placeholder="Friendly name for reference"
 label="Name"
 data="selected.name"
 validate="/Data/validate.js name"
 invalid={!selectedNameIsValidData}
 onChange={selectedNameChangeData}
 value={selectedNameValueData}
/>
{children}
</React.Fragment>)
}